query WfaSessionIssuesFilterOptions($runId: ConditionID!) {
	filter_groups: issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		url_group_uniq_array
		severity_name_group_uniq_array
		type_name_group_uniq_array
	}
	issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		conformance
	}
}
